import React from 'react'
import { Alert } from 'react-bootstrap'
import { difference, keys, get } from 'lodash'

import { getText } from '../../lib/text'
import Button from '../../components/Button'
import { printMoney } from '../../../lib/Tools.js'

function reportDates(o, n) {
  const added = difference(n, o)
  const removed = difference(o, n)

  if (added.length && removed.length) return (
    <span>
      Se han cambiado las fechas {removed.map(x => <span key={x}><code key={x}>{x}</code>, </span>)}
      por {added.map(x => <span key={x}><code key={x}>{x}</code>, </span>)}
    </span>
  )
  else if (added.length) return (
    <span>
      Se han añadido las fechas {added.map(x => <span key={x}><code key={x}>{x}</code>, </span>)}
    </span>
  )
  else if (removed.length) return (
    <span>
      Se han eliminado las fechas {removed.map(x => <span key={x}><code key={x}>{x}</code>, </span>)}
    </span>
  )
  else return null
}

/**
 * Lista de reservas con problemas
 */

export const UnusedReservations = ({ trip, reservations, unusedReservations, removeReservation, suppliers }) => (
  unusedReservations.length > 0 && (
    <Alert bsStyle="danger" style={{ marginTop: 10 }}>
      ERROR: Esto se reservó, pero fue eliminado de la ruta:
      <ul>
        {
          unusedReservations
            .map(key => reservations[trip._id + key])
            .map(r => {
              if (r.supplier && !suppliers[r.supplier]) {
                console.error(`Supplier with id ${r.supplier} wasn't found in suppliers collection`)
              }
              
              const supplierText = r.supplier 
                ? (get(suppliers, [r.supplier, "name"], "SUPPLIER NOT FOUND") + ", ")
                : "" 
              
              return (
                !r
                  ? <li>{"Reservation doesn't exist?"}</li>
                  : (
                    <li key={r.itemKey}>
                      <Button
                        bsSize="xsmall"
                        glyph="remove"
                        onClick={() => removeReservation(r._id)}
                        tooltipText={getText("Eliminar reserva (ya no sirve)")}
                      />
                      {"  "}
                      {r.name}
                      ({supplierText}
                      {printMoney(r.finalPrice || 0)}€, {r.date}{r.time ? ` ${r.time}` : ""})
                      { r.notes ? <span> (Nota: <span style={{fontStyle: "italic"}}>{r.notes}</span>)</span> : "" }
                    </li>
                  )
              )
            })
        }
      </ul>
    </Alert>
  )
)

export const BrokenReservations = ({ trip, reservations, brokenReservations, approve, remove, suppliers }) => {
  if (keys(brokenReservations).length == 0) return null

  return (
    <Alert bsStyle="danger" style={{ marginTop: 10 }}>
      ERROR: Ha habido cambios en la ruta, puede que estas reservas ya no sirvan:
      <ul>
        {
          keys(brokenReservations)
            .map(key => reservations[trip._id + key])
            .map(r => {
              const changes = brokenReservations[r.itemKey]
              return (
                <li key={r.itemKey}>
                  <Button
                    bsSize="xsmall"
                    glyph="remove"
                    onClick={() => remove(r._id)}
                    tooltipText={getText("Eliminar reserva (ya no sirve)")}
                  />
                  <Button
                    bsSize="xsmall"
                    glyph="ok"
                    onClick={() => approve(r._id, changes)}
                    tooltipText={getText("OK, la reserva sigue valiendo, o yo lo corrijo")}
                  />
                  {"  "}
                  {r.name}
                  ({r.supplier ? `${suppliers[r.supplier].name}, ` : ""}
                  {printMoney(r.finalPrice || 0)}€, {r.date}{r.time ? ` ${r.time}` : ""}):
                  <ul>
                    {
                      changes.map(({ field, newValue, rValue }) => (
                        field == "repetitionDates"
                          ? <li key={field}>{reportDates(rValue, newValue)}</li>
                          : <li key={field}><i>{getText(field)}</i> pasó de <i>{rValue}</i> a <i>{newValue}</i></li>
                      ))
                    }
                  </ul>
                </li>
              )
            })
        }
      </ul>
    </Alert>
  )
}
